// src/value/AppConst.js

const minimalTradeTimesHelp = <div>
    최소 거래 횟수만큼의 매수가 있어야만 매도조건을 검사하여 매도하며, 그 이전에는 매도하지 않습니다.
</div>;
const buyIntervalHelp = <div>
    기본 매수 간격(일 단위)을 설정합니다. 이 값은 매수 주문 간의 기준 간격을 결정합니다. 시장이 열린 날만 헤아리며 20일은 약 1개월에 해당합니다.
</div>;
const buyAmountHelp = <div>
    기본 매수 금액(원 단위)을 설정합니다. 이 값은 매수 주문 시 사용되는 기본 금액입니다.
</div>;
const bullIntervalFactorHelp = <div>
    지난 번 매수했을 때 보다 상승했을 경우에 매수 간격을 더 짧게 하거나 길게 조정할 수 있습니다.
    상승 시 매수간격 조절 배율을 설정합니다. 매수 간격을 줄이려면 100% 미만으로,
    간격을 늘리려면 100% 이상의 값을 설정합니다.
</div>;
const bearIntervalFactorHelp = <div>
    지난 번 매수했을 때 보다 하락했을 경우에 매수 간격을 더 짧게 하거나 길게 조정할 수 있습니다.
    하락 시 매수간격 조절 배율을 설정합니다. 매수 간격을 줄이려면 100% 미만으로,
    간격을 늘리려면 100% 이상의 값을 설정합니다.
</div>;
const avgDownFactorMaxHelp = <div>
    매수를 실행할 때 상태가 손실일 경우 매수금액을 늘일 수 있습니다.
    이 값이 100%보다 크면, 손실률에 따라 매수금액을 늘리는데, 이 비율을 얼마만큼까지 늘릴 수 있는지를 설정합니다.
    이 비율과 손실율을 곱한 만큼을 매수금액에 더하여 매수합니다.<br/>
    (150%인 경우 0.5 * 손실율 * 매수금액 + 매수금액)
</div>;
const acceptableChangeHelp = <div>
    지난 번 매수했을 때 보다 상승(D) 또는 하락(E)했을 경우에 매수 간격을 조정할 수 있지만,
    너무 작은 변화는 무시하는 것이 좋습니다.
    그렇게 무시할 수 있는 상승 또는 하락폭을 설정합니다. 이 값보다 상승 또는 하락했을 경우에만 매수간격을 조정합니다.
</div>;
const exitOnProfitHelp = <div>
    전체 매도할 수익률을 설정합니다. 이 값 이상으로 수익이 발생하면 전체 매도를 준비합니다.
</div>;
const partialSellOnProfitHelp = <div>
    부분 매도를 실행할 수익률을 설정합니다. 이 값 이상으로 수익이 발생하면 부분 매도를 진행합니다.
</div>;
const partialSellThresholdHelp = <div>
    부분 매도를 실행할 경우, 전체 보유 대비 부분 매도할 비중을 설정합니다.
</div>;
const suddenDropBuyThresholdHelp = <div>
    급격한 하락이 있을 때 추가매수를 할 수 있는데, 이 때의 하락 기준을 설정합니다. 롤링 최고가를 기준으로 합니다.
</div>;
const suddenDropBuyFactorHelp = <div>
    급격한 하락이 있을 때, 기본 매수 금액의 몇 %를 추가로 매수할지를 설정합니다. 추가매수를 하지 않을 경우 0으로 설정합니다.
    추가매수는 기본매수 간격에 영향을 끼지지 않습니다. (별개의 매수)
</div>;
const rollingHighPeriodHelp = <div>
    급격한 하락을 판단하기 위한 롤링 최고가 기간(일)을 설정합니다.
    과거 이 기간 동안의 최고가로부터 당일 시가가 급락률(K)을 초과하여 하락했을 때 추가 매수를 진행합니다.
    이 때 매수를 하고나면, 다시 이 기간 동안에는 추가 매수를 하지 않습니다.
</div>;

const exitOnProfitDropHelp = <div>
    전체 매도할 수익률 지점에 도달한 후 최고가로부터 이 비율만큼 떨어지면 진짜로 모두 매도.
</div>;

export const DefaultRule = {
    minimalTradeTimes: { default: 5, min: 1, max: 10, help: minimalTradeTimesHelp }, // 최소 거래 횟수
    buyInterval: { default: 20, min: 3, max: 40, help: buyIntervalHelp }, // 기본 매수 간격 (일 단위)
    buyAmount: { default: 500000, min: 10, max: 10000000, help: buyAmountHelp }, // 기본 매수 금액 (원 단위) - 어쩌면 달러도 나중에는...
    bullIntervalFactor: { default: 1.0, min: 0.3, max: 2.0, help: bullIntervalFactorHelp }, // 상승 시 매수간격 조절 배율
    bearIntervalFactor: { default: 1.0, min: 0.3, max: 2.0, help: bearIntervalFactorHelp }, // 하락 시 매수간격 조절 배율
    avgDownFactorMax: { default: 1.2, min: 1.0, max: 3.0, help: avgDownFactorMaxHelp }, // 손실을 보고 있을 때 매수금액 증액 비율 최대값
    acceptableChange: { default: 0.05, min: 0.02, max: 1.0, help: acceptableChangeHelp }, // 무시할 수 있는 상승 또는 하락폭
    exitOnProfit: { default: 0.3, min: 0.1, max: 3.0, help: exitOnProfitHelp }, // 전체 매도할 수익률
    partialSellOnProfit: { default: 0.2, min: 0.1, max: 1.0, help: partialSellOnProfitHelp }, // 부분 매도 실행 수익률
    partialSellThreshold: { default: 0.0, min: 0.0, max: 0.5, help: partialSellThresholdHelp }, // 부분 매도 비중
    suddenDropBuyThreshold: { default: 0.15, min: 0.1, max: 0.5, help: suddenDropBuyThresholdHelp }, // 급락매수 기준 하락률
    suddenDropBuyFactor: { default: 0.2, min: 0, max: 1.0, help: suddenDropBuyFactorHelp }, // 급락매수 시 매수금액 비율
    rollingHighPeriod: { default: 5, min: 1, max: 30, help: rollingHighPeriodHelp }, // 급락기준 롤링 최고가 기간 (일 단위)
    // exitOnProfit 지점에 도달한 후 최고가로부터 이 비율만큼 떨어지면 진짜로 모두 매도.
    exitOnProfitDrop: { default: 0.03, min: 0.01, max: 0.1, help: exitOnProfitDropHelp },
};


export const AppStyle = {
    LinkColor: '#2f20b1',
    PrimaryRGB:'#1976d2', WarnRGB: '#ed6c02', ErrorRGB: '#d32f2f', 
    InfoRGB: '#0288d1', SecondaryRGB:'#9c27b0', SuccessRGB:'#2e7d32',
    DisabledRGB: '#777',
    Button: {
        go: {backgroundColor:'#004343',color:'yellow'},
        warn: {backgroundColor:'#ff0000',color:'white', border:'1px solid black'},
        gray: {backgroundColor:'#cecece',color:'black'}
    },
    BorderCCC: '1px solid #cccccc',
    BorderEEE: '1px solid #eeeeee',
    BorderRed: '1px solid #f00',
    mui: {
        primary:'primary', info:'info', action:'action',
        success:'success', warning:'warning', error:'error',
        disabled:'disabled', secondary:'secondary', inherit:'inherit',
        contained:'contained', outlined: 'outlined', text:'text', default: 'default'
    }
};
